import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import styled from 'styled-components';
export const StyledSelectInput = styled(Select) `
  font-family: 'Segoe UI';
  font-size: 16px;
  border-radius: 6px;
`;
//# sourceMappingURL=index.js.map